module.exports = __webpack_public_path__ + "assets/img/terrestrial.12e26304.jpg";